<template>
    <div>
        <v-container fluid class="pa-6 ">
            <DatatableV2 :displayTitle="false" :flat="false" :url="apiUrl" @openLibraryDialog="openLibraryDialog" />
            <LibraryDialogComponent v-if="formLib" :form="formLib" :libType="libType" @cancel="formLib = null;" :showLibraryDialog="showLibraryDialog" @hideLibraryDialog="showLibraryDialog = false;" :libParams="{ 'rpSubType': 'campSMSconversational' }" />
        </v-container>
    </div>
</template>

<script>
import DatatableV2 from '@/components/DatatableV2';
import GenericDataService from '@/services/GenericDataService';
import LibraryDialogComponent from "@/components/dialogs/LibraryDialogComponent";

export default {
    name: "CampaignSMSConversationalList",
    components: {
        DatatableV2,
        LibraryDialogComponent,
    },
    data() {
        return {
            apiUrl: "/retroplanning/list?type=CAMP_CALL&sousType=campSMSconversational",
            formLib: null,
            libType: "SMS",
            showLibraryDialog: false,
        }
    },
    methods: {
        openLibraryDialog() {
            GenericDataService.getData("/library/getFilters?libType=" + this.libType + "&filters[filters.type]=[\"CONVERSATIONAL\"]").then((response) => {
                this.formLib = response.data.data;
                this.showLibraryDialog = true;
            });
        },
    },
};
</script>